"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TopBannerSkeleton = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
/**
 * Skeleton component for `TopBanner`.
 */
const TopBannerSkeleton = ({
  animation = 'pulse',
  className
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: className,
    "data-testid": getTestId(_constants.TOP_BANNER_SKELETON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BannerSkeleton, {
      variant: "rectangular",
      animation: animation
    })
  });
};
exports.TopBannerSkeleton = TopBannerSkeleton;
